const UserRole = {
  Admin: 'admin',
  Conductor: 'conductor',
  Staff: 'staff',
  Inspector: 'inspector',
  Dispatcher: 'dispatcher'
};

export default UserRole;
